export default "__VITE_ASSET__BRG5cIE2__"